import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiAnalyzeEvidenceRequest,
  DefaultApiGetEvidenceFileRequest,
  DefaultApiGetEvidencesRequest,
  DefaultApiSearchEvidencesRequest,
  DefaultApiGetEvidencesCountRequest,
  DefaultApiGetCardTransactionEvidenceRecordsRequest,
  DefaultApiGetPaymentRequestEvidenceRecordsRequest,
  DefaultApiGetPaymentRequestEvidenceRecordFileRequest,
  DefaultApiGetCardTransactionEvidenceRecordImageRequest,
  DefaultApiUpdateEvidenceInfoRequest,
  DefaultApiUpdatePaymentRequestEvidenceFileRequest,
  DefaultApiUpdateEvidenceImageRequest,
  DefaultApiDeleteEvidenceRequest,
  DefaultApiGetEvidenceInformationForCardTransactionsRequest,
  DefaultApiGetEvidenceImageRequest,
  DefaultApiUploadCardTransactionEvidenceImageRequest,
  DefaultApiGetLockStatusOfEvidencesRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const analyzeEvidence = async (
  instance: AxiosInstance,
  params: DefaultApiAnalyzeEvidenceRequest
) => {
  return await userApiDefaultApiFactory(instance).analyzeEvidence(params)
}

export const getEvidenceFile = async (
  instance: AxiosInstance,
  params: DefaultApiGetEvidenceFileRequest
) => {
  return await userApiDefaultApiFactory(instance).getEvidenceFile(params)
}

export const getEvidences = async (
  instance: AxiosInstance,
  params: DefaultApiGetEvidencesRequest
) => {
  return await userApiDefaultApiFactory(instance).getEvidences(params)
}

export const searchEvidences = async (
  instance: AxiosInstance,
  params: DefaultApiSearchEvidencesRequest
) => {
  return await userApiDefaultApiFactory(instance).searchEvidences(params)
}

export const getEvidencesCount = async (
  instance: AxiosInstance,
  params: DefaultApiGetEvidencesCountRequest
) => {
  return await userApiDefaultApiFactory(instance).getEvidencesCount(params)
}

export const getCardTransactionEvidenceRecords = async (
  instance: AxiosInstance,
  params: DefaultApiGetCardTransactionEvidenceRecordsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getCardTransactionEvidenceRecords(params)
}

export const getPaymentRequestEvidenceRecords = async (
  instance: AxiosInstance,
  params: DefaultApiGetPaymentRequestEvidenceRecordsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getPaymentRequestEvidenceRecords(params)
}

export const getPaymentRequestEvidenceRecordFile = async (
  instance: AxiosInstance,
  params: DefaultApiGetPaymentRequestEvidenceRecordFileRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getPaymentRequestEvidenceRecordFile(params)
}

export const getCardTransactionEvidenceRecordImage = async (
  instance: AxiosInstance,
  params: DefaultApiGetCardTransactionEvidenceRecordImageRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getCardTransactionEvidenceRecordImage(params)
}

export const updateEvidenceInfo = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateEvidenceInfoRequest
) => {
  return await userApiDefaultApiFactory(instance).updateEvidenceInfo(params)
}

export const updatePaymentRequestEvidenceFile = async (
  instance: AxiosInstance,
  params: DefaultApiUpdatePaymentRequestEvidenceFileRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).updatePaymentRequestEvidenceFile(params)
}

export const updateEvidenceImage = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateEvidenceImageRequest
) => {
  return await userApiDefaultApiFactory(instance).updateEvidenceImage(params)
}

export const deleteEvidence = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteEvidenceRequest
) => {
  return await userApiDefaultApiFactory(instance).deleteEvidence(params)
}

export const getEvidenceInformationForCardTransactions = async (
  instance: AxiosInstance,
  params: DefaultApiGetEvidenceInformationForCardTransactionsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getEvidenceInformationForCardTransactions(params)
}

export const getEvidenceImage = async (
  instance: AxiosInstance,
  params: DefaultApiGetEvidenceImageRequest
) => {
  return await userApiDefaultApiFactory(instance).getEvidenceImage(params)
}

export const uploadCardTransactionEvidenceImage = async (
  instance: AxiosInstance,
  params: DefaultApiUploadCardTransactionEvidenceImageRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).uploadCardTransactionEvidenceImage(params)
}

export const getLockStatusOfEvidences = async (
  instance: AxiosInstance,
  params: DefaultApiGetLockStatusOfEvidencesRequest
) => {
  return await userApiDefaultApiFactory(instance).getLockStatusOfEvidences(
    params
  )
}

// Do Not Remove this line ===@import api client===
